import { DatePicker } from "antd";
import { useEffect, useState } from 'react';
import stylesContainer from "../../../../../pages/PreferencePage/Content/SetArrivalTime/ArrivalTimes/style.module.scss";
import { datetime } from "../../../../../util/library/datetime";
import { selectPermissions } from "../../../../../util/store/selectors";
import { useSelector } from "../../../../../util/store/store";
import { SHORT_TIME_FORMAT } from "../../../../../util/varibles/constants";
import { getElById } from "../../../../../util/varibles/global";
import { ACTION } from "../../../../../util/varibles/permission";
import styles from "./style.module.scss";

const disabledDate = (current: any, prev: any) => {
    return prev && current < datetime(prev.time).startOf('day').time;
}

function range(start: number, end: number) {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}

const disabledTime = (current: any, prev: any) => {
    if (current && prev) {
        const currentDate = datetime(current).startOf('day').time;
        if (currentDate !== datetime(prev.time).startOf('day').time)
            return false;

        const hour = datetime(prev.time).hour;
        const hourCurrent = current.get('hour');

        const disable: any = {
            disabledHours: () => range(0, hour),
        }
        if (hourCurrent === hour) {
            const minus = datetime(prev.time).minute;
            disable.disabledMinutes = () => range(0, minus + 1)
        }
        return disable
    }
    return false
}

const timeColors = ['#2F8ED5', '#1B6399', '#56A513', '#818e98'];

interface IProps {
    item: any
    format: any
    isEdit: boolean
    timeDisabled: number
    handleChangeTime: any
}

const Time: React.FC<IProps> = (props) => {
    const { item, format, timeDisabled, handleChangeTime } = props;
    const [{ isOpen, value }, setState] = useState<{ isOpen: boolean, value: any }>({ isOpen: false, value: null })
    const [canUpdateOperation] = useSelector(selectPermissions([ACTION.OPERATION.UPDATE]));
    const isEdit = props.isEdit && canUpdateOperation;

    useEffect(() => {
        return () => {
            document.removeEventListener('click', handleClickLayout);
            setState(prev => ({ ...prev, isOpen: false }))
        }
        // The layout listener is registered imperatively by togglePicker and cleaned up on unmount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const togglePicker = (isOpen: any) => {
        setState({ isOpen, value: datetime(item.time).value },)
        if (isOpen) {
            document.addEventListener('click', handleClickLayout)
        } else {
            document.removeEventListener('click', handleClickLayout)
        }
    }

    const handleClickLayout = (e: any) => {
        const { target } = e;
        const { index } = props.item;
        const el = target.closest(`.${styles['info-time']}, .ant-picker-dropdown , .${styles['dropdown-picker']}`);
        if (el) {
            if (el.id !== 'info-time-' + index && el.className.includes(`${styles['info-time']}`)) {
                togglePicker(false);
            }
        } else {
            togglePicker(false);
        }
    }

    return <div key={item.time} {...{
        className: styles['wrapper-time'],
        tabIndex: 1,
        title: item.placeHolder
    }}>
        <div className={styles['icon']} style={{ background: timeColors[item.type] }} />
        <div className={styles['container-time']}>
            <span {...{ className: styles['name-location'], title: item.title }}>{item.title}</span>
            <div {...{
                className: styles['time'],
                "data-is-edit": isEdit,
            }}>
                <div {...{
                    id: 'info-time-' + item.index,
                    className: styles['info-time'],
                    onClick: () => togglePicker(true)
                }}>
                    <div {...{ className: styles['name'] }}>
                        {datetime(item.time).format(format)}
                    </div>
                </div>
                {isEdit && <DatePicker
                    disabledDate={current => disabledDate(current, timeDisabled)}
                    disabledTime={current => disabledTime(current, timeDisabled)}
                    classNames={{
                        popup: { root: stylesContainer['dropdown-picker'] }
                    }}
                    {...{
                        getPopupContainer: () => getElById('popup-operation-info'),
                        className: styles['date-picker'],
                        value,
                        showTime: {
                            minuteStep: 15,
                            format: SHORT_TIME_FORMAT
                        },
                        open: isOpen,
                        onOk: () => togglePicker(false),
                        onChange: (e: any) => {
                            togglePicker(false);
                            handleChangeTime(e);
                        },

                    }}
                />}
            </div>
        </div>

    </div>;
}

export default Time;
